import axios from 'axios';

export default {
  selectors: (params = {}) => axios.get('skills/selectors', { params }),
  index: (params = {}) => axios.get('skills', { params }),
  store: (payload = {}) => axios.post('skills', payload),
  update: (skillId, payload = {}) => axios.put(`skills/${skillId}`, payload),
  delete: (skillId) => axios.delete(`skills/${skillId}`),
};
